// extracted by mini-css-extract-plugin
export default {"overlay":"cQ_kG","container":"cQ_g","header":"cQ_c9","logo":"cQ_gp","title":"cQ_cX","closeButton":"cQ_fP","closeButtonIcon":"cQ_hR"};